import React, { useEffect, useMemo, useState } from "react";
import { useIntl } from "react-intl";
import { clone, isEmpty, isNil } from "ramda";
import { Box, Button, Tab, Tabs } from "@mui/material";
import { TabContext, TabPanel } from "@mui/lab";
import AssetInfoForm from "../AssetInfoForm";
import { ThemeProvider } from "styled-components";
import { getMuiTheme } from "../../../../utils/utils";

import PolylineData from "../PolylineData/polylineData";
import EquipmentInfo from "../EquipmentInfo/equipmentInfo";
import palette from "../../../../../config/colorPalette";
import { saveAsset } from "../ThresholdsValues/utils";
import { useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { getPointsByAssets } from "../../../../api";
const AddStructure = () => {
  const intl = useIntl();
  const theme = useMemo(() => getMuiTheme(), []);
  const navigate = useNavigate();
  const { state: locationState } = useLocation();
  const [mode, setMode] = useState("");
  const [edition, setEdition] = useState(false);
  const [assetId, setAssetId] = useState("");

  const userData = useSelector((state) => state.userData.data);
  const configData = useSelector((state) => state.configData.data);
  const equipmentTypes = useSelector((state) => state.equipmentTypeData.data);
  const assetData = useSelector((state) => state.assetsData.data);
  const [objectMeasures, setObjectMeasures] = useState(null);
  useEffect(() => {
    if (!isNil(equipmentTypes)) {
      const newData = equipmentTypes.map((item) => {
        const measures = [];
        item.measurands.forEach((measure, index) => {
          measures.push(measure.ref);
        });

        const newEntry = { name: item.name, measures: measures };
        return newEntry;
      });
      setObjectMeasures(newData);
    }
  }, [equipmentTypes]);
  const [value, setValue] = useState("tab1");
  const [errors, setErrors] = useState([]);
  const [loadingScreen, setLoadingScreen] = useState(false);

  const [assetName, setAssetName] = useState("");
  const [URL, setURL] = useState("");
  const [zoom, setZoom] = useState(12);
  const [demarcation, setDemarcation] = useState(
    !isNil(configData) && !isNil(configData.demarcations) && !isEmpty(configData.demarcations)
      ? configData.demarcations[0]
      : "",
  );
  const [assetMeasurands, setAssetMeasurands] = useState([]);
  const [assetModules, setAssetModules] = useState([]);
  const [assetPackages, setAssetPackages] = useState([]);
  const [assetSensors, setAssetSensors] = useState(null);
  const [assetPackagesValidation, setAssetPackagesValidation] = useState([]);
  const [assetAdditionalSensors, setAssetAdditionalSensors] = useState(null);
  const [assetExternalServices, setAssetExternalServices] = useState([]);
  const [assetExternalServicesCheck, setAssetExternalServicesCheck] = useState(false);
  const [assetExternalServicesFields, setAssetExternalServicesFields] = useState([]);
  const [assetSubs, setAssetSubs] = useState([]);
  const [moreSubsAllowed, setMoreSubsAllowed] = useState(false);
  const [alertTimeRange, setAlertTimeRange] = useState(24);
  const [alertTimeMeasure, setAlertTimeMeasure] = useState(1);
  const [avatar, setAvatar] = useState("");
  const [equipmentCollection, setEquipmentCollection] = useState([""]);
  const [measures, setMeasures] = useState({ equipment1: [""] });
  const [measuresComputed, setMeasuresComputed] = useState({ equipment1: [] });
  const [measuresAlerts, setMeasuresAlerts] = useState({ equipment1: [0] });
  const [thresholdsValues, setThresholdsValues] = useState({ equipment1: [[[[{ type: null, value: 0 }]]]] });
  const [thresholdsRanges, setThresholdsRanges] = useState({ equipment1: [[[[0, 1]]]] });
  const [zones, setZones] = useState({});
  const [polylineDisplay, setPolylineDisplay] = useState([]);
  //polyline
  const [polyline, setPolyline] = useState([]);
  const [centroid, setCentroid] = useState([]);
  const [pIndexes, setPIndexes] = useState(null);
  //equipment
  const [equipment, setEquipment] = useState([]);
  const [infoToggle, setInfoToggle] = useState([]);
  const [alertConfigToggle, setAlertConfigToggle] = useState([]);
  const [channelAsignToggle, setChannelAsignToggle] = useState([]);
  const [channelNameAsignToggle, setChannelNameAsignToggle] = useState([]);
  const [channelDataToggle, setChannelDataToggle] = useState([]);
  const [channelPK, setChannelPK] = useState([]);
  const [equipmentInterMeasurement, setEquipmentInterMeasurement] = useState([]);
  const [measureToggle, setMeasureToggle] = useState([]);
  const [channelToggle, setChannelToggle] = useState([]);
  const [zoneToggle, setZoneToggle] = useState([]);
  const [substructureAsignToggle, setSubstructureAsignToggle] = useState([]);
  const [substructureDataToggle, setSubstructureDataToggle] = useState([]);
  const [criticalPolygon, setCriticalPolygon] = useState([]);
  const [protectionPolygon, setProtectionPolygon] = useState([]);
  const [inclusionArea, setInclusionAreas] = useState([]);
  const [inclinometers, setInclinometers] = useState([]);
  const [areasToggle, setAreasToggle] = useState([]);

  const [mixAreas, setMixAreas] = useState([]);
  const [criticalAreas, setCriticalAreas] = useState([]);
  const [protectionAreas, setProtectionAreas] = useState([]);
  const [areasDefToggle, setAreasDefToggle] = useState([]);
  const [selectingCenter, setSelectingCenter] = useState([]);
  const [inclusionPoint, setInclusionPoint] = useState([]);
  const [inclusionRange, setInclusionRange] = useState([]);
  const [selectingExclusion, setSelectingExclusion] = useState([]);
  const [exclusionPoint, setExclusionPoint] = useState([]);
  const [exclusionRange, setExclusionRange] = useState([]);
  const [timeOutDisable, setTimeOutDisable] = useState([]);

  const [badEquipmentList, setBadEquipmentList] = useState([]);

  useMemo(async () => {
    const mode = locationState?.mode;
    const assetData = locationState?.actualData;
    if (mode === "edit" && !isNil(equipmentTypes)) {
      setLoadingScreen(true);
      setMode("edit");
      setEdition(true);
      const equipmentData = assetData.equipments;
      //1ST TAB
      setAssetName(assetData.name);
      setAssetId(assetData.id);
      setZoom(assetData.zoom);
      setDemarcation(assetData.demarcation);
      setAvatar(assetData.image);
      setAssetModules(assetData.config.modules);
      setAssetSubs(assetData.substructures);
      let newZones = {};
      for (let indexSub = 0; indexSub < assetData.substructures.length; indexSub++) {
        newZones[`sub${indexSub + 1}`] = [];
        for (let indexZone = 0; indexZone < assetData.substructures[indexSub].zones.length; indexZone++) {
          newZones[`sub${indexSub + 1}`].push({
            ini: assetData.substructures[indexSub].zones[indexZone].ini,
            end: assetData.substructures[indexSub].zones[indexZone].end,
            alertsConfigurations: assetData.substructures[indexSub].zones[indexZone].alertsConfigurations,
          });
        }
      }
      if (!isNil(assetData.config) && !isNil(assetData.config.additionalSensors)) {
        const assetSensIDs = [];
        for (let index = 0; index < assetData.config.additionalSensors.sensors.length; index++) {
          assetSensIDs.push(assetData.config.additionalSensors.sensors[index].sensor_ID);
        }
        setAssetSensors(assetSensIDs);
      }
      setAssetExternalServicesFields(
        !isNil(assetData.config.externalServices) ? assetData.config.externalServices.filter((es) => es.active) : [],
      );
      const newServicesValues = [];
      for (let indexService = 0; indexService < assetData.config?.externalServices?.length; indexService++) {
        if (assetData.config.externalServices[indexService].active) {
          const auxConfigForm = [];
          for (const field of assetData.config.externalServices[indexService].configForm) {
            const found = newServicesValues.find((sv) => sv.ref === field.name);
            if (!found) {
              let newObject = field;
              newObject.ref = field.name;
              newObject.value = field.value;
              auxConfigForm.push(newObject);
            }
          }
          let auxFinalObject = assetData.config.externalServices[indexService];
          auxFinalObject.configForm = auxConfigForm;
          newServicesValues.push(auxFinalObject);
        }
      }
      setAssetExternalServices(newServicesValues);
      if (!isNil(assetData.config.externalServices)) setAssetExternalServicesCheck(true);
      setAssetAdditionalSensors(!isNil(assetData.config.additionalSensors) ? assetData.config.additionalSensors : null);
      setEquipment(equipmentData);
      const newEquipmentCollection = [];
      const newTimeOutDisable = [];
      for (let indexEquipment = 0; indexEquipment < equipmentData.length; indexEquipment++) {
        newEquipmentCollection.push(equipmentData[indexEquipment].equipmentType);
        newTimeOutDisable.push(isNil(equipmentData[indexEquipment].measurementInfo.timeout));
      }
      setEquipmentCollection(newEquipmentCollection);
      setTimeOutDisable(newTimeOutDisable);
      //2ND TAB
      setCentroid(assetData.centroid);
      const response = await getPointsByAssets(assetData.name);
      setPolyline(response.data.data);
      const uniquePolylines = Object.values(
        response.data.data.reduce((acc, polyline) => {
          const current = acc[polyline.id];

          if (!current || polyline.points.length < current.points.length) {
            acc[polyline.id] = polyline;
          }

          return acc;
        }, {}),
      );

      const modifiedPolylines = uniquePolylines.map((polyline) => {
        const modifiedPoints = polyline.points.map((point) => {
          if (typeof point.latitude !== "number" || typeof point.longitude !== "number") {
            throw new Error("bad.structure");
          }

          return {
            ...point,
            lat: point.latitude,
            lng: point.longitude,
          };
        });

        return {
          ...polyline,
          points: modifiedPoints,
        };
      });
      setPolylineDisplay(modifiedPolylines);
      //3RD TAB
      //Toggles
      const newInfoToggle = [];
      const newAlertConfigToggle = [];
      const newAreasToggle = [];
      const newChannelToggle = [];
      const newChannelAsignToggle = [];
      const newChannelNameAsignToggle = [];
      const newChannelDataToggle = [];
      const newSubDataToggle = [];
      const newSubAsignToggle = [];
      const newZoneToggle = [];
      //Data
      const newChannelPK = [];
      const newMixAreas = [];
      const newCriticalAreas = [];
      const newProtectionAreas = [];
      const newAreasDefToggle = [];
      const newSelectingCenter = [];
      const newInclusionPoint = [];
      const newInclusionRange = [];
      const newSelectingExclusion = [];
      const newExclusionPoint = [];
      const newExclusionRange = [];
      const newMeasurands = [];

      for (let indexEquipment = 0; indexEquipment < equipmentData.length; indexEquipment++) {
        const typeData = equipmentTypes.find((et) => et.name === equipmentData[indexEquipment].equipmentType);
        if (typeData) {
          if (typeData.measurands) {
            typeData.measurands.forEach((msr) => {
              if (!newMeasurands.some((existing) => existing === msr)) {
                newMeasurands.push(msr);
              }
            });
          }
        }
        newInfoToggle.push(false);
        newAlertConfigToggle.push(false);
        newAreasToggle.push(false);
        newChannelToggle.push([]);
        newChannelDataToggle.push([]);
        newChannelAsignToggle.push([]);
        newChannelNameAsignToggle.push([]);
        newZoneToggle.push([]);
        newSubDataToggle.push([]);
        newSubAsignToggle.push([]);
        newChannelPK.push([]);
        newSelectingCenter.push([]);
        newInclusionPoint.push([]);
        newInclusionRange.push([]);
        newSelectingExclusion.push([]);
        newExclusionPoint.push([]);
        newExclusionRange.push([]);
        newAreasDefToggle.push([]);
        if (!isNil(equipmentData[indexEquipment].areas) && !isNil(equipmentData[indexEquipment].areas.main)) {
          const areas = equipmentData[indexEquipment].areas;
          const dasPolylines = response.data.data?.filter((p) => p.equipment_type === "DAS");
          if (dasPolylines.length > 1 && areas.main.length === 1) {
            newMixAreas[indexEquipment] = true;
          } else {
            newMixAreas[indexEquipment] = false;
          }

          newCriticalAreas.push(areas.main[0].critical.distance);
          newProtectionAreas.push(areas.main[0].protection.distance);
          if (!isNil(equipmentData[indexEquipment].areas.extra)) {
            newSelectingCenter[indexEquipment].push(false);
            for (let indexExtra = 0; indexExtra < equipmentData[indexEquipment].areas.extra?.length; indexExtra++) {
              newInclusionPoint[indexEquipment].push(
                equipmentData[indexEquipment].areas.extra[indexExtra].geometry.coordinates,
              );
              newInclusionRange[indexEquipment].push(equipmentData[indexEquipment].areas.extra[indexExtra].distance);
            }
          }
          if (!isNil(equipmentData[indexEquipment].areas.avoid)) {
            newSelectingExclusion[indexEquipment].push(false);
            for (let indexAvoid = 0; indexAvoid < equipmentData[indexEquipment].areas.avoid?.length; indexAvoid++) {
              newExclusionPoint[indexEquipment].push(
                equipmentData[indexEquipment].areas.avoid[indexAvoid].geometry.coordinates,
              );
              newExclusionRange[indexEquipment].push(equipmentData[indexEquipment].areas.avoid[indexAvoid].distance);
            }
          }
          newAreasDefToggle[indexEquipment].push([false, false]);
        } else {
          newMixAreas.push(false);
          newCriticalAreas.push(null);
          newProtectionAreas.push(null);
          newSelectingCenter[indexEquipment].push(null);
          newInclusionPoint[indexEquipment].push(null);
          newInclusionRange[indexEquipment].push(null);
          newSelectingExclusion[indexEquipment].push(null);
          newExclusionPoint[indexEquipment].push(null);
          newExclusionRange[indexEquipment].push(null);
          newAreasDefToggle[indexEquipment].push([false, false]);
        }
        for (let indexChannel = 0; indexChannel < equipmentData[indexEquipment].channels.length; indexChannel++) {
          newChannelToggle[indexEquipment].push(false);
          newChannelDataToggle[indexEquipment].push(false);
          newChannelAsignToggle[indexEquipment].push(false);
          newChannelNameAsignToggle[indexEquipment].push(false);
          newZoneToggle[indexEquipment].push([]);
          newZoneToggle[indexEquipment][indexChannel].push([false]);
          newSubDataToggle[indexEquipment].push([]);
          newSubAsignToggle[indexEquipment].push([]);
          newChannelPK[indexEquipment].push(
            Math.round(response.data.data[0].points[response.data.data[0].points.length - 1].pk * 100) / 100,
          );

          for (
            let indexSub = 0;
            indexSub < equipmentData[indexEquipment].channels[indexChannel].substructures.length;
            indexSub++
          ) {
            newSubDataToggle[indexEquipment][indexChannel].push(false);
            newSubAsignToggle[indexEquipment][indexChannel].push(false);
          }
        }
      }
      setMixAreas(newMixAreas);
      setInfoToggle(newInfoToggle);
      setAlertConfigToggle(newAlertConfigToggle);
      setAreasToggle(newAreasToggle);
      setChannelToggle(newChannelToggle);
      setChannelDataToggle(newChannelDataToggle);
      setChannelAsignToggle(newChannelAsignToggle);
      setChannelNameAsignToggle(newChannelNameAsignToggle);
      setSubstructureDataToggle(newSubDataToggle);
      setSubstructureAsignToggle(newSubAsignToggle);
      setZoneToggle(newZoneToggle);
      setZones(newZones);
      setChannelPK(newChannelPK);
      setCriticalAreas(newCriticalAreas);
      setProtectionAreas(newProtectionAreas);
      setAreasDefToggle(newAreasDefToggle);
      setSelectingCenter(newSelectingCenter);
      setInclusionPoint(newInclusionPoint);
      setInclusionRange(newInclusionRange);
      setSelectingExclusion(newSelectingExclusion);
      setExclusionPoint(newExclusionPoint);
      setExclusionRange(newExclusionRange);
      setAssetMeasurands(newMeasurands);
      setLoadingScreen(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [locationState, equipmentTypes]);

  const areaDisplayer = useMemo(() => {
    if (!isNil(configData) && !isNil(assetExternalServices)) {
      const aisService = configData.externalServices.find((es) => es.category === "ais");

      return aisService.services.some((miItem) => assetExternalServices.some((item) => item.ref === miItem.ref));
    }
    return null;
  }, [configData, assetExternalServices]);

  useEffect(() => {
    if (!isNil(areaDisplayer) && !areaDisplayer && !isNil(equipment)) {
      let newEquipments = clone(equipment);
      let newCriticalAreas = clone(criticalAreas);
      let newProtectionAreas = clone(criticalPolygon);
      let newAreasDefToggle = clone(areasDefToggle);
      let newSelectingCenter = clone(selectingCenter);
      let newInclusionPoint = clone(inclusionPoint);
      let newInclusionRange = clone(inclusionRange);
      let newSelectingExclusion = clone(selectingExclusion);
      let newExclusionPoint = clone(exclusionPoint);
      let newExclusionRange = clone(exclusionRange);
      for (let indexEquipment = 0; indexEquipment < newEquipments.length; indexEquipment++) {
        if (newEquipments[indexEquipment].equipmentType === "DAS") {
          newCriticalAreas[indexEquipment] = 0;
          newProtectionAreas[indexEquipment] = 0;
          newAreasDefToggle[indexEquipment] = [false, false];
          newSelectingCenter[indexEquipment] = [];
          newInclusionPoint[indexEquipment] = [];
          newInclusionRange[indexEquipment] = [];
          newSelectingExclusion[indexEquipment] = [];
          newExclusionPoint[indexEquipment] = [];
          newExclusionRange[indexEquipment] = [];
          newEquipments[indexEquipment].areas.avoid = null;
          newEquipments[indexEquipment].areas.extra = null;
          newEquipments[indexEquipment].areas.main = null;
        }
      }
      setEquipment(newEquipments);
      setCriticalAreas(newCriticalAreas);
      setProtectionAreas(newProtectionAreas);
      setAreasDefToggle(newAreasDefToggle);
      setSelectingCenter(newSelectingCenter);
      setInclusionPoint(newInclusionPoint);
      setInclusionRange(newInclusionRange);
      setSelectingExclusion(newSelectingExclusion);
      setExclusionPoint(newExclusionPoint);
      setExclusionRange(newExclusionRange);
    } else if (!isNil(areaDisplayer) && areaDisplayer && !isNil(equipment)) {
      let newEquipments = clone(equipment);
      let newCriticalAreas = clone(criticalAreas);
      let newProtectionAreas = clone(criticalPolygon);
      let newAreasDefToggle = clone(areasDefToggle);
      let newSelectingCenter = clone(selectingCenter);
      let newInclusionPoint = clone(inclusionPoint);
      let newInclusionRange = clone(inclusionRange);
      let newSelectingExclusion = clone(selectingExclusion);
      let newExclusionPoint = clone(exclusionPoint);
      let newExclusionRange = clone(exclusionRange);
      for (let indexEquipment = 0; indexEquipment < newEquipments.length; indexEquipment++) {
        newCriticalAreas[indexEquipment] = 0;
        newProtectionAreas[indexEquipment] = 0;
        newAreasDefToggle[indexEquipment] = [false, false];
        newSelectingCenter[indexEquipment] = [];
        newInclusionPoint[indexEquipment] = [];
        newInclusionRange[indexEquipment] = [];
        newSelectingExclusion[indexEquipment] = [];
        newExclusionPoint[indexEquipment] = [];
        newExclusionRange[indexEquipment] = [];
        if (newEquipments[indexEquipment].equipmentType === "DAS") {
          newEquipments[indexEquipment].areas.avoid = [
            {
              distance: 0,
              geometry: {
                type: "Point",
                coordinates: null,
              },
            },
          ];
          newEquipments[indexEquipment].areas.extra = [
            {
              distance: 0,
              geometry: {
                type: "Point",
                coordinates: null,
              },
            },
          ];
          newEquipments[indexEquipment].areas.main = [
            {
              polyline: 0,
              critical: {
                distance: 0,
                geometry: {
                  type: "Polygon",
                  coordinates: null,
                },
              },
              protection: {
                distance: 0,
                geometry: {
                  type: "Polygon",
                  coordinates: null,
                },
              },
            },
          ];
        }
      }
      setEquipment(newEquipments);
      setCriticalAreas(newCriticalAreas);
      setProtectionAreas(newProtectionAreas);
      setAreasDefToggle(newAreasDefToggle);
      setSelectingCenter(newSelectingCenter);
      setInclusionPoint(newInclusionPoint);
      setInclusionRange(newInclusionRange);
      setSelectingExclusion(newSelectingExclusion);
      setExclusionPoint(newExclusionPoint);
      setExclusionRange(newExclusionRange);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [areaDisplayer]);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const disabled = useMemo(
    () => !isEmpty(errors) || isEmpty(polyline) || isEmpty(centroid) || isEmpty(equipment),
    [errors, polyline, centroid, equipment],
  );

  return (
    <ThemeProvider theme={theme}>
      {loadingScreen && (
        <div
          style={{
            position: "absolute",
            width: "90%",
            height: "100%",
            backgroundColor: "rgb(176 176 176 / 60%)",
            zIndex: 1001,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            flexDirection: "column",
          }}
        >
          <h1>{`${intl.formatMessage({ id: "loading" })}...`}</h1>
        </div>
      )}
      <div style={{ height: "100%", width: "100%", overflowY: "auto" }}>
        <TabContext value={value}>
          <Box sx={{ width: "100%" }}>
            <Tabs value={value} onChange={handleChange}>
              <Tab id={"tab1"} value={"tab1"} label={intl.formatMessage({ id: "asset.data" })} />
              <Tab id={"tab2"} value={"tab2"} label={intl.formatMessage({ id: "polyline.data" })} />
              <Tab id={"tab3"} value={"tab3"} label={intl.formatMessage({ id: "equipment.info" })} />
            </Tabs>
          </Box>
          <TabPanel sx={{ flex: 1, overflow: "auto", width: "100%", height: "100%" }} value={"tab1"} key={"tab1"}>
            <AssetInfoForm
              zoom={zoom}
              setZoom={setZoom}
              demarcation={demarcation}
              setDemarcation={setDemarcation}
              URL={URL}
              setURL={setURL}
              assetName={assetName}
              setAssetName={setAssetName}
              avatar={avatar}
              setAvatar={setAvatar}
              equipment={equipment}
              setEquipment={setEquipment}
              equipmentCollection={equipmentCollection}
              setEquipmentCollection={setEquipmentCollection}
              measures={measures}
              setMeasures={setMeasures}
              measuresComputed={measuresComputed}
              setMeasuresComputed={setMeasuresComputed}
              measuresAlerts={measuresAlerts}
              setMeasuresAlerts={setMeasuresAlerts}
              thresholdsValues={thresholdsValues}
              setThresholdsValues={setThresholdsValues}
              errors={errors}
              setErrors={setErrors}
              alertTimeRange={alertTimeRange}
              alertTimeMeasure={alertTimeMeasure}
              setAlertTimeRange={setAlertTimeRange}
              setAlertTimeMeasure={setAlertTimeMeasure}
              zones={zones}
              setZones={setZones}
              thresholdsRanges={thresholdsRanges}
              setThresholdsRanges={setThresholdsRanges}
              objectMeasures={objectMeasures}
              configData={configData}
              equipmentTypes={equipmentTypes}
              assetAdditionalSensors={assetAdditionalSensors}
              assetExternalServices={assetExternalServices}
              assetMeasurands={assetMeasurands}
              setAssetAdditionalSensors={setAssetAdditionalSensors}
              setAssetExternalServices={setAssetExternalServices}
              setAssetMeasurands={setAssetMeasurands}
              assetExternalServicesCheck={assetExternalServicesCheck}
              setAssetExternalServicesCheck={setAssetExternalServicesCheck}
              assetExternalServicesFields={assetExternalServicesFields}
              setAssetExternalServicesFields={setAssetExternalServicesFields}
              setMoreSubsAllowed={setMoreSubsAllowed}
              key={"tab1infoform"}
              setPolyline={setPolyline}
              polylineDisplay={polylineDisplay}
              setPolylineDisplay={setPolylineDisplay}
              setCentroid={setCentroid}
              edition={edition}
              setEdition={setEdition}
            />
          </TabPanel>
          <TabPanel value={"tab2"} key={"tab2"}>
            <PolylineData
              setPolyline={setPolyline}
              polylineDisplay={polylineDisplay}
              setPolylineDisplay={setPolylineDisplay}
              centroid={centroid}
              setCentroid={setCentroid}
              edition={edition}
              setEdition={setEdition}
              pIndexes={pIndexes}
              equipment={equipment}
              setEquipment={setEquipment}
              setPIndexes={setPIndexes}
              key={"tab2PolylineData"}
              equipmentCollection={equipmentCollection}
              badEquipmentList={badEquipmentList}
              setBadEquipmentList={setBadEquipmentList}
              assetSubs={assetSubs}
              setAssetSubs={setAssetSubs}
              assetSensors={assetSensors}
              setAssetSensors={setAssetSensors}
              zones={zones}
              setZones={setZones}
              errors={errors}
              setErrors={setErrors}
              zoom={zoom}
              setZoom={setZoom}
              intl={intl}
            ></PolylineData>
          </TabPanel>
          <TabPanel value={"tab3"} key={"tab3"}>
            <EquipmentInfo
              equipment={equipment}
              setEquipment={setEquipment}
              equipmentCollection={equipmentCollection}
              polylineDisplay={polylineDisplay}
              centroid={centroid}
              pIndexes={pIndexes}
              assetName={assetName}
              measuresComputed={measuresComputed}
              measures={measures}
              realPolyline={polyline}
              setMeasures={setMeasures}
              measuresAlerts={measuresAlerts}
              setMeasuresAlerts={setMeasuresAlerts}
              thresholdsValues={thresholdsValues}
              setThresholdsValues={setThresholdsValues}
              thresholdsRanges={thresholdsRanges}
              setThresholdsRanges={setThresholdsRanges}
              zones={zones}
              setZones={setZones}
              infoToggle={infoToggle}
              setInfoToggle={setInfoToggle}
              channelAsignToggle={channelAsignToggle}
              setChannelAsignToggle={setChannelAsignToggle}
              channelNameAsignToggle={channelNameAsignToggle}
              setChannelNameAsignToggle={setChannelNameAsignToggle}
              channelDataToggle={channelDataToggle}
              setChannelDataToggle={setChannelDataToggle}
              channelPK={channelPK}
              setChannelPK={setChannelPK}
              equipmentInterMeasurement={equipmentInterMeasurement}
              setEquipmentInterMeasurement={setEquipmentInterMeasurement}
              measureToggle={measureToggle}
              setMeasureToggle={setMeasureToggle}
              channelToggle={channelToggle}
              setChannelToggle={setChannelToggle}
              zoneToggle={zoneToggle}
              setZoneToggle={setZoneToggle}
              errors={errors}
              setErrors={setErrors}
              objectMeasures={objectMeasures}
              moreSubsAllowed={moreSubsAllowed}
              substructureAsignToggle={substructureAsignToggle}
              setSubstructureAsignToggle={setSubstructureAsignToggle}
              substructureDataToggle={substructureDataToggle}
              setSubstructureDataToggle={setSubstructureDataToggle}
              criticalPolygon={criticalPolygon}
              inclinometers={inclinometers}
              inclusionArea={inclusionArea}
              protectionPolygon={protectionPolygon}
              setCriticalPolygon={setCriticalPolygon}
              setInclinometers={setInclinometers}
              setInclusionAreas={setInclusionAreas}
              setProtectionPolygon={setProtectionPolygon}
              areasToggle={areasToggle}
              setAreasToggle={setAreasToggle}
              configData={configData}
              exclusionPoint={exclusionPoint}
              exclusionRange={exclusionRange}
              inclusionPoint={inclusionPoint}
              inclusionRange={inclusionRange}
              selectingCenter={selectingCenter}
              selectingExclusion={selectingExclusion}
              setExclusionPoint={setExclusionPoint}
              setExclusionRange={setExclusionRange}
              setInclusionPoint={setInclusionPoint}
              setInclusionRange={setInclusionRange}
              setSelectingCenter={setSelectingCenter}
              setSelectingExclusion={setSelectingExclusion}
              areasDefToggle={areasDefToggle}
              setAreasDefToggle={setAreasDefToggle}
              mode={mode}
              intl={intl}
              criticalAreas={criticalAreas}
              protectionAreas={protectionAreas}
              setCriticalAreas={setCriticalAreas}
              setProtectionAreas={setProtectionAreas}
              assetData={assetData}
              assetAdditionalSensors={assetAdditionalSensors}
              assetExternalServices={assetExternalServices}
              assetMeasurands={assetMeasurands}
              assetModules={assetModules}
              equipmentTypes={equipmentTypes}
              alertConfigToggle={alertConfigToggle}
              key={"tab3EquipmentInfo"}
              setAlertConfigToggle={setAlertConfigToggle}
              areaDisplayer={areaDisplayer}
              mixAreas={mixAreas}
              setMixAreas={setMixAreas}
              setTimeOutDisable={setTimeOutDisable}
              edition={edition}
              setEdition={setEdition}
              timeOutDisable={timeOutDisable}
              assetSubs={assetSubs}
              setAssetSubs={setAssetSubs}
            ></EquipmentInfo>
          </TabPanel>
        </TabContext>
        <div
          style={{
            width: "100%",
            height: "1px",
            backgroundColor: palette.primary,
            margin: "8px 0",
          }}
        ></div>
        <div>
          <Button
            variant="contained"
            id="save_data_button"
            style={{
              backgroundColor: disabled ? palette.light : palette.primary,
              color: "white",
            }}
            disabled={disabled}
            onClick={() => {
              saveAsset({
                assetName,
                zoom,
                demarcation,
                assetModules,
                measures,
                measuresAlerts,
                thresholdsValues,
                track: polyline,
                centroid,
                equipments: equipment,
                image: avatar,
                alertTimeRange,
                alertTimeMeasure,
                userData,
                setLoadingScreen,
                thresholdsRanges,
                assetMeasurands,
                assetExternalServices,
                assetAdditionalSensors,
                exclusionPoint,
                exclusionRange,
                inclusionPoint,
                inclusionRange,
                navigate,
                mode: locationState?.mode,
                assetId,
                intl,
              });
            }}
          >
            {intl.formatMessage({ id: "save" })}
          </Button>
        </div>
      </div>
    </ThemeProvider>
  );
};

export default AddStructure;
